import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(160deg, #fef2f2 0%, #fee2e2 100%);
  padding: 20px;
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
`;

const Card = styled.div`
  background: #fff;
  border-radius: 24px;
  padding: 48px 40px;
  max-width: 420px;
  width: 100%;
  text-align: center;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
`;

const Icon = styled.div`
  font-size: 64px;
  margin-bottom: 24px;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: #dc2626;
  margin: 0 0 12px;
`;

const Subtitle = styled.p`
  font-size: 15px;
  color: #64748b;
  line-height: 1.6;
  margin: 0 0 24px;
`;

const InfoBox = styled.div`
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 24px;
  text-align: left;
`;

const InfoLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #991b1b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
`;

const InfoText = styled.div`
  font-size: 14px;
  color: #7f1d1d;
`;

const ContactText = styled.p`
  font-size: 13px;
  color: #94a3b8;
  margin: 0 0 24px;
  
  a {
    color: #2563eb;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;

const LogoutBtn = styled.a`
  display: inline-block;
  padding: 12px 32px;
  background: #f1f5f9;
  color: #64748b;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s;
  
  &:hover {
    background: #e2e8f0;
    color: #475569;
  }
`;

const BannedPage: React.FC = () => {
  return (
    <Container>
      <Card>
        <Icon>🚫</Icon>
        <Title>Akun Dinonaktifkan</Title>
        <Subtitle>
          Akun Anda telah dinonaktifkan oleh administrator dan tidak dapat mengakses Kindergame.
        </Subtitle>
        
        <InfoBox>
          <InfoLabel>Status</InfoLabel>
          <InfoText>Akun dibanned secara permanen sampai ada perubahan dari admin.</InfoText>
        </InfoBox>
        
        <ContactText>
          Jika merasa ini kesalahan, silakan hubungi{' '}
          <a href="mailto:support@kindergame.id">support@kindergame.id</a>
        </ContactText>
        
        <LogoutBtn href="/">
          Kembali ke Beranda
        </LogoutBtn>
      </Card>
    </Container>
  );
};

export default BannedPage;
